define('fukit/behavior/resolve.route.behavior',['require','exports','module','marionette','backbone.radio','appkit/util/key.prefixer','../helpers/route.helper'],function(require, exports, module) {
  //prettier-ignore
  var Mn          = require('marionette'),
      Radio       = require('backbone.radio'),
      KeyPrefixer = require('appkit/util/key.prefixer'),
      RouteHelper = require('../helpers/route.helper');

  var ResolveRouteBehavior = Mn.Behavior.extend(
    {
      defaults: {
        // the name of the route that needs to be resolved
        route: null,
        // the params that need to be resolved with the route
        params: null,
      },

      initialize: function() {
        Mn.Behavior.prototype.initialize.apply(this, arguments);
        this.setupStateListener();
      },

      onFirstBeforeRender: function() {
        this.updateLink();
      },

      updateLink: function() {
        //prettier-ignore
        var route  = this.getOption('route') || this.view.getOption('route'),
            params = this.getOption('params') || this.view.getOption('params');
        if (route) {
          this.view.link = this.generateItemLink(route, params);
        }
      },

      generateItemLink: function(route, params) {
        if (params) {
          params = this.resolveRouteParams(params);
        }

        if (route) {
          return RouteHelper.resolve(route, params);
        }
      },

      resolveRouteParams: function(params) {
        var model = this.getOption('model') || this.view.model;
        return ResolveRouteBehavior.resolveRouteParams(params, model);
      },

      setupStateListener: function() {
        var state = Radio.channel('AppKit.controllerService').request('state');

        this.listenTo(state, 'change', function() {
          this.updateLink();
        });
      },
    },
    {
      resolveRouteParams: function(params, model) {
        var state = Radio.channel('AppKit.controllerService').request('state');

        return KeyPrefixer.resolve(params, {
          '@state.': function(stateKey) {
            if (state) {
              return state.get(stateKey);
            }
          },
          '@model.': function(modelKey) {
            if (model) {
              return model.get(modelKey);
            }
          },
        });
      },
    }
  );

  module.exports = ResolveRouteBehavior;
});

